import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
  AfterViewChecked,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChatInternalService } from '../../../services/chat-internal.service';
import { M_ChatInternalMessage } from '../../../models/M_ChatInternal';

@Component({
  selector: 'app-chat-internal-messages',
  templateUrl: './chat-internal-messages.component.html',
  styleUrls: ['./chat-internal-messages.component.css'],
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
})
export class ChatInternalMessagesComponent implements OnChanges, AfterViewChecked {
  @Input() conversationId: number | null = null;

  messages: M_ChatInternalMessage[] = [];
  loading = false;

  @ViewChild('messagesContainer') private messagesContainer: ElementRef | undefined;

  private chatService = inject(ChatInternalService);
  private cdr = inject(ChangeDetectorRef);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['conversationId'] && this.conversationId !== null) {
      this.loadMessages();
    }
  }

  ngAfterViewChecked(): void {
    this.scrollToBottom();
  }

  loadMessages(): void {
    if (!this.conversationId) return;

    this.loading = true;
    this.chatService.getMessages(this.conversationId).subscribe({
      next: (r) => {
        this.messages = r.data;
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdr.markForCheck();
      },
    });
  }

  addMessage(message: M_ChatInternalMessage): void {
    this.messages.push(message);
    this.cdr.markForCheck();
  }

  renderContent(content: string): string {
    return content
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\n/g, '<br>')
      .replace(/- (.*?)(<br>|$)/g, '&bull; $1$2');
  }

  private scrollToBottom(): void {
    if (this.messagesContainer) {
      const el = this.messagesContainer.nativeElement;
      el.scrollTop = el.scrollHeight;
    }
  }
}
